import MetaTag from "components/Common/Meta-tag"
import React from "react"
import InvestmentLeadDetails from "./Details"

function InvestmentLeadDetail() {
    return (
        <>
            <MetaTag title={"Investment Lead Details"} />
            <InvestmentLeadDetails />
        </>
    )
}

export default InvestmentLeadDetail
